import styled, { css } from "styled-components";

import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  Component
} from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// import { ContextConsumer } from "../App";

import CardNew, { CardFlatten } from "../PAcardNew";

import Tap from "react-interactions";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import { countMenu } from "./PAtopMenu";
import { solutions } from "../../data/solutions";
import { xsollaProducts } from "../../data/xsollaProducts";
import PAtopMenu, { MenuSol } from "./PAtopMenu";


export default function PAsolutionsMenu() {

  const getRenderArray = (prods)=>{
    let prodArr = [];
    prods.forEach((oneProd)=>{
      if (typeof oneProd['product'] === 'string') {
        if (prodArr.indexOf(oneProd['product']) < 0) {
          prodArr.push(oneProd['product'])
        }
      } else {
        oneProd['product'].forEach((oneProdName)=>{
          if (prodArr.indexOf(oneProdName) < 0) {
            prodArr.push(oneProdName)
          }
        })
      }
    })
    return prodArr
  }

  const [state, setState] = useState({
    active: Object.keys(xsollaProducts)[0],
    activeProducts: [],
    renderProducts: [],
  })

  const handleSolutionHover = (active = false, prods = []) => {
    let prodsArray = getRenderArray(prods);
    if (active) {
      console.log('active = ', active);
      console.log('prods = ', prods);
      console.log('prodsArray = ', prodsArray);
    }
    setState({
      ...state,
      active: active,
      renderProducts: prodsArray,
    })
  }


  return (
    <div>
    {/* <MenuContext.Provider
      value={{
        menuState: state
      }}> */}

    <MenuCont menu={true}>
      <MenuUl count={countMenu()}>
        {/* {state.renderProducts} */}
        <PAtopMenu
         selected={state.renderProducts}
        />
      </MenuUl>
    </MenuCont>

      {/* <h1>{state['active']}</h1> */}
      <MenuSol count={solutions.length}>
        {solutions.map((oneSolution, u) => {
          return (
            <div
            key={`oneSolution['id']_${u}`}
            // onClick={() => {
            //   handleSolutionHover(oneSolution['id'])
            // }}
              onMouseEnter={() => {
                handleSolutionHover(oneSolution['id'], oneSolution['products'])
              }}
              onMouseOut={() => {
                handleSolutionHover()
              }}
            >

            <CardNew
              key={`${oneSolution["name"]}___${u}`}
              appearance="transparent"
              indentation="lg"
              >
              <div style={{ color: "currentColor" }}
              >
                <h3>{oneSolution["name"]}</h3>
                <FormGroup border="lg">

                  <h4>{oneSolution["description"]}</h4>


                {oneSolution.products.map((oneProduct, i) => {
                  return (
                    <FormGroup
                    key={`${oneProduct["name"]}__${i}`}

                    >

                        <span>{oneProduct["name"]}</span>

                        <div
                          style={{
                            display: "inline-flex",
                            position: "relative",
                            bottom: -7
                          }}
                          >
                          {typeof oneProduct.product === "string" ? (
                            xsollaProducts[oneProduct.product] ? (
                              <div
                                style={{ width: "24px", height: "24px" }}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    xsollaProducts[oneProduct.product]["icon"]
                                  }}
                              />
                              ) : (
                                oneProduct.product
                                )
                                ) : (
                            oneProduct.product.map((oneProductName, ii) => {
                              return (
                                <div
                                key={`${oneProductName}_${ii}`}
                                style={{ width: "24px", height: "24px" }}
                                  dangerouslySetInnerHTML={{
                                    __html:
                                    xsollaProducts[oneProductName]["icon"]
                                  }}
                                  />
                                  );
                                })
                          )}
                        </div>

                    </FormGroup>
                  );
                })}

              </FormGroup>

              </div>
            </CardNew>
        </div>
          );
        })}
      </MenuSol>
      {/* </MenuContext.Provider> */}
    </div>
  );
}





const MenuUl = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1080px;
  display: grid;
  /* grid-template-columns: repeat(4, minmax(100px, auto)); */
  grid-template-columns:(auto-fit, repeat(
    ${props => props.count},
    ${props => `1fr`}
  ));
  place-content: center center;
  /* grid-column-gap: ${props => `${props.count > 4 ? 3 : props.count}%`}; */
`




const MenuCont = styled.div`
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: all 0.2s ease;
  ${props =>
    props.menu &&
    css`
      /* min-height: 800px; */
    `}
  ${props =>
    props.hide &&
    css`
      opacity: 0;
    `}

`


const CssSolutionsLi = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  transition: background-color .15s ease-in-out, color .15s ease-in-out;
  &:hover {
    background-color: rgba(0,118,255,.08);
    color: #0076ff
  }
`

const StyledLink = styled(Link)`
  color: red;
  background: blue;
`


const H44 = styled.div`
color: currentColor;
font-size: 14px;
font-weight: bolder;
color: rgba(0, 36, 77, 1);
${props =>
    props.active &&
    css`
      color: #0073f7;
    `}
`